<template>
    <transition name="down">
        <div class="menu">

            <Head @ck="closeMenu" :x="true">{{ $t("til")}}</Head>
            <div class="logo"></div>
            <div class="cont">
                <div class="item logout" @click="clickLogout">{{ $t("logout.txt")}}</div>
                <div class="item" :class="{acc:menuEnb==='main'}" @click="gotolink('main')">{{ $t("menu.toDay")}}</div>
                <div class="item" :class="{acc:menuEnb==='myclass'}" @click="gotolink('myclass')">{{ $t("menu.myClass")}}</div>
                <div class="item" :class="{acc:menuEnb==='mynote'}" @click="gotolink('mynote')">{{ $t("menu.myNote")}}</div>
                <div class="item" :class="{acc:menuEnb==='mytest'}" @click="gotolink('mytest')">{{ $t("menu.myTest")}}</div>
                <div class="item" :class="{acc:menuEnb==='mydoc'}" @click="gotolink('mydoc')">{{ $t("menu.myDoc")}}</div>
            </div>
            <div class="user" @click="clickLogout"></div>
        </div>

    </transition>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'Menu',
    mixins: [mainDelegate],
    data() {
        return {
            menuEnb: 'main'
        }
    },
    computed: {
        acc() {
            return this.$route.name
        }
    },
    methods: {
        closeMenu() {
            this.menuOpen = false
        },
        clickLogout() {
            this.$modal.show('dialog', {
                title:
                    this.userData.UserName + ' ' + this.$t('logout.dialog')[0],
                // text: 'You are too awesome',
                buttons: [
                    {
                        title: this.$t('logout.dialog')[1],
                        handler: () => {
                            this.closeMenu()
                            this.logoutApi()
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                        title: this.$t('logout.dialog')[2]
                    }
                ]
            })
        },
        gotolink(name) {
            this.closeMenu()
            this.$router.push({ name })
        }
    },
    watch: {
        acc(val, old) {
            switch (old) {
                case 'mynote':
                    val === 'word' ? (this.menuEnb = 'mynote') : ''
                    break
                case 'myclasslist':
                    val === 'word' ? (this.menuEnb = 'myclass') : ''
                    break
                case 'mydoc':
                    switch (val) {
                        case 'word':
                            this.menuEnb = 'myclass'
                            return
                            break
                        case 'test':
                            this.menuEnb = 'mytest'
                            return
                            break
                        case 'examend':
                            this.menuEnb = 'mydoc'
                            return
                            break
                    }
                    break
            }
            switch (val) {
                case 'myclasslist':
                    return (this.menuEnb = 'myclass')
                    break
                case 'exam':
                    return (this.menuEnb = 'mytest')
                    break
            }
            this.menuEnb = val
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@bar-h: 80px;
.menu {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 500;
    width: 100%;
    height: 100vh;
    background: @main-color;
    overflow-y: hidden;
}
.logo {
    display: none;
    width: 258px;
    height: @bar-h;
    background: url('../assets/img/nav-logo-default.png');
    background-repeat: no-repeat;
    background-position: center;
    margin: 0px 85px 0px 128px;
}
.user {
    display: none;
    width: 60px;
    height: @bar-h;
    background: url('../assets/img/user-login.png');
    background-repeat: no-repeat;
    background-position: center;
    margin: 0px 140px 0px 0px;
    cursor: pointer;
}
.cont {
    margin: 43px 50px;
    .item {
        // margin-top: 10px;
        height: 43px;
        border-bottom: solid 2px #b0d9d6;
        line-height: 50px;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
        &:active {
            color: #ddd;
        }
    }
}
.down-enter-active,
.down-leave-active {
    transition: all 0.5s;
}
.down-enter,
.down-leave-to {
    height: 0vh;
}
@media only screen and (min-width: @rwd) {
    .menu {
        position: static;
        width: 100%;
        height: auto;
        background: @main-color;
        box-shadow: 0px 3px 5px #0000001c;
    }
    .logo {
        display: block;
        float: left;
    }
    .cont {
        float: left;
        margin: 0px;
        .item {
            float: left;
            width: 187px;
            height: @bar-h;
            margin: 0px 0px 0px -60px;
            font-size: 20px;
            line-height: @bar-h;
            border-bottom: none;
            cursor: pointer;
            &.acc {
                background: url('../assets/img/rectangle-10.png');
            }
            &:hover {
                color: #ddd;
            }
        }
        .logout {
            display: none;
        }
    }
    .user {
        display: block;
        float: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue